module.exports = __webpack_public_path__ + "static/media/home-text-behind-transparent-mobile.81b3d594.png";